<script>
  import TryButton from '$lib/TryButton.svelte'
  import WatchDemoButton from '$lib/WatchDemoButton.svelte'
</script>

<div class="flex flex-col md:flex-row items-center justify-center px-8 md:px-16 pt-10 lg:px-24 lg:gap-10 h-full">
  <main class="">
    <div class="w-full flex flex-col justify-between">
      <h1 class="text-4xl lg:text-5xl font-bold text-am-black max-w-xl">
        <span class="text-am-white-60">AI-Powered</span> B2B Meeting Qualification Platform
      </h1>

      <div class="flex flex-col">
        <p class="mt-6 text-am-black-75 max-w-md text-lg">
          AddMeetings filters your cold meeting requests with intent-based AI so only the most relevant, high-value ones
          reach your inbox. Skip sharing manual links and endless back and forth. Just say, “Meet me on AddMeetings.”
        </p>

        <div class="mt-10 flex flex-wrap gap-4">
          <TryButton>Start Qualifying Meetings for Free</TryButton>
          <WatchDemoButton href="https://youtu.be/7gSFB1X--88" />
        </div>
      </div>
    </div>
  </main>

  <div class="relative aspect-video rounded-xl flex-1 overflow-hidden h-full max-h-[95vh] mt-16 lg:mt-0 w-full">
    <iframe
      class="w-full h-full"
      src="https://www.youtube.com/embed/U6azi6oXxo8?si=pvd4ae2tFXb1EpqH?rel=0&modestbranding=1&autoplay=1&controls=1&loop=1&mute=1"
      title="Product Demo Video"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  </div>
</div>

<!-- Trusted By Section -->
<div class="flex flex-col md:flex-row items-center justify-center gap-8 mt-16 border-b border-am-white-80 pb-8">
  <span class="text-[#8a8c94] text-lg">Trusted by:</span>
  <div class="flex flex-wrap items-center justify-center gap-14">
    <img src="/leo-capital.png" alt="Leo Capital" class="h-8" />
    <img src="/founders-live.png" alt="Founders Live" class="h-8 bg-black" />
    <img src="/innovation-norway.png" alt="Innovation Norway" class="h-8" />
    <img src="/startup_lab.png" alt="Startup Lab" class="h-20" />
    <img src="/maria_01.png" alt="Maria 01" class="h-20" />
    <img src="/CHARGE_LOGO.webp" alt="Maria 01" class="h-6" />
  </div>
</div>

<style>
  :global(body) {
    margin: 0;
    font-family:
      system-ui,
      -apple-system,
      sans-serif;
  }
</style>
